//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** System Communication Guids */
export const Communication = {
    /** The 'Blank' Communication Template that ships with Rock */
    CommunicationTemplateBlank: "A3C7F623-7F6F-4C48-B66F-CBEE2DF30B6A",
    /** The default email template for sending emails using Rock's Communications Wizard. */
    CommunicationTemplateDefault: "88B7DF18-9C30-4BAC-8CA2-5AD253D57E4D",
};
